// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"678":"component---src-pages-index-js","883":"component---src-pages-404-js","989":"component---src-templates-blog-post-js"}[chunkId] + "-" + {"678":"53c1f47360fc48579e99","883":"4ec50fd34ce2d4fab7bd","989":"cdcbfb93412768bbb2b2"}[chunkId] + ".js";
};